import * as AuthAPI from "../api/auth";
import * as DummyAuthAPI from "../dummyApi/auth";
import { isDemoMode } from "../stores/mode";
import type { AuthResponse, FinishAuthResponse, JWTResponse, AssessTurnstileResponse } from "../api/auth";
import type { AuthData } from "../helpers/auth/auth";

interface AuthApi {
  authAnonymous: (data: AuthData) => Promise<JWTResponse>;
  start: (channel: string, data: AuthData) => Promise<AuthResponse>;
  assessTurnstile: (token: string, campaign: string) => Promise<AssessTurnstileResponse>;
  exchangeTemporaryJWT: (fingerprint: string, tempJwt: string, turnstileToken?: string) => Promise<JWTResponse>;
  finishYoutube: (token: string) => Promise<FinishAuthResponse>;
}

const getAPI = (): AuthApi => {
  return isDemoMode() ? DummyAuthAPI : AuthAPI;
};

export const authAnonymous = async (data: AuthData): Promise<JWTResponse> => {
  return getAPI().authAnonymous(data);
};

export const start = async (channel: string, data: AuthData): Promise<AuthResponse> => {
  return getAPI().start(channel, data);
};

export const assessTurnstile = async (token: string, campaign: string): Promise<AssessTurnstileResponse> => {
  return getAPI().assessTurnstile(token, campaign);
};

export const exchangeTemporaryJWT = async (
  fingerprint: string,
  tempJwt: string,
  turnstileToken?: string
): Promise<JWTResponse> => {
  return getAPI().exchangeTemporaryJWT(fingerprint, tempJwt, turnstileToken);
};

export const finishYoutube = (token: string): Promise<FinishAuthResponse> => {
  return getAPI().finishYoutube(token);
};
